import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import parseHtmlToReact from 'html-react-parser';
import PropTypes from 'prop-types';

import { Status } from 'components';
import { getFeedbackErrorMessage, getFeedbackSuccessMessage } from 'store/ProductDetails/selectors';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const FeedbackStatus = ({ isError, message }) => {
  return (
    <div className={cx('container')}>
      {message && (
        <Status className={[cx('status'), isError ? 'error' : 'attention']}>
          {parseHtmlToReact(message)}
        </Status>
      )}
    </div>
  );
};

FeedbackStatus.propTypes = {
  isError: PropTypes.bool,
  message: PropTypes.string,
};

const getMessage = (state, { isError }) =>
  isError ? getFeedbackErrorMessage(state) : getFeedbackSuccessMessage(state);
const mapStateToProps = (state, ownProps) => ({
  message: getMessage(state, ownProps),
});

export default connect(mapStateToProps)(FeedbackStatus);
